// extracted by mini-css-extract-plugin
export default {"aboutPage":"about_aboutPage__pxYwV","container":"about_container__10d19","imgItem":"about_imgItem__U04FZ"};